import { desktop, tablet } from '@thrivent/midwest-shared';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const smallBP = 497;
export const smallWidthBreakpoint = `@media screen and (min-width: ${smallBP}px)`;

// --------------------------------------------------------------------------

export const PageSection = styled.div<{
  isBgDark?: boolean;
  isBgGradient?: boolean;
  forceMobileBreakpoint?: boolean;
}>`
  ${({ forceMobileBreakpoint, theme, isBgGradient }) => `
    ${
      !forceMobileBreakpoint &&
      `
      ${tablet} {
          background-image:
            ${
              isBgGradient
                ? `linear-gradient(to right, 
                    ${theme.midwestColors.backgroundSecondary} 0%, 
                    ${theme.midwestColors.white} 55%,
                    ${theme.midwestColors.backgroundSecondary} 100%)`
                : 'none'
            };
        }
      `
    }
  `}
`;

export const Container = styled.div``;

export const StaticIndicator = styled.button`
  display: none;
  position: absolute;
  top: 222px;
  width: 32px;
  height: 32px;
  font-size: 1rem;
  border: 2px solid;
  background-color: white;
  border-color: ${({ theme }) =>
    theme.midwestColors.identityBrandPrimaryMedium};
  color: ${({ theme }) => theme.midwestColors.identityBrandPrimaryMedium};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: 1;
  margin-left: 1rem;
  transition: transform 0.3s;
  &:hover,
  &:focus {
    cursor: pointer;
    box-shadow: ${({ theme }) =>
      `0 0 10px 0 ${theme.midwestColors.identityBrandPrimaryMedium}`};
  }

  &:hover {
    transform: rotate(0deg) !important;
  }

  ${smallWidthBreakpoint} {
    display: flex;
    top: 222px;
  }

  ${desktop} {
    top: 230px;
  }
`;
